<template>
  <DsShowcase title="FormFieldPlay" description="Campo com integração VeeValidate. Suporta validação automática, prop 'as' para renderizar inputs, e scoped slots.">
    <!-- PROP: as (shortcut mode) -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">as (shortcut mode)</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'InputPlayV3' | 'TextareaPlayV2' | 'SelectPlayV2' | 'MultiselectPlayV2'</code> — renderiza o componente automaticamente</p>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">⚠️ Requer <code>&lt;Form&gt;</code> do VeeValidate como parent</p>
      <div class="tw:max-w-lg tw:p-4 tw:border tw:rounded-lg tw:bg-gray-50/50">
        <p class="tw:text-sm tw:opacity-60 tw:italic">Este componente precisa estar dentro de um &lt;Form&gt; do VeeValidate para funcionar. Veja uso real nas views.</p>
      </div>
    </section>

    <!-- PROP: rules -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">rules</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string | object</code> — regras de validação VeeValidate (ex: <code>'required|email'</code>)</p>
      <div class="tw:max-w-lg tw:p-4 tw:border tw:rounded-lg tw:space-y-2">
        <code class="tw:text-xs tw:block">&lt;FormFieldPlay name="email" label="E-mail" rules="required|email" as="InputPlayV3" /&gt;</code>
        <p class="tw:text-xs tw:opacity-50">Exibe mensagem de erro abaixo do campo automaticamente.</p>
      </div>
    </section>

    <!-- Props overview -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Todas as props</h2>
      <div class="tw:overflow-x-auto">
        <table class="tw:text-xs tw:w-full tw:border-collapse">
          <thead>
            <tr class="tw:border-b">
              <th class="tw:text-left tw:py-2 tw:pr-4">Prop</th>
              <th class="tw:text-left tw:py-2 tw:pr-4">Tipo</th>
              <th class="tw:text-left tw:py-2">Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw:border-b"><td class="tw:py-2 tw:pr-4 tw:font-mono">name</td><td class="tw:pr-4">string</td><td>Nome do campo (obrigatório, usado pelo VeeValidate)</td></tr>
            <tr class="tw:border-b"><td class="tw:py-2 tw:pr-4 tw:font-mono">label</td><td class="tw:pr-4">string</td><td>Label exibida acima</td></tr>
            <tr class="tw:border-b"><td class="tw:py-2 tw:pr-4 tw:font-mono">description</td><td class="tw:pr-4">string</td><td>Texto auxiliar abaixo</td></tr>
            <tr class="tw:border-b"><td class="tw:py-2 tw:pr-4 tw:font-mono">rules</td><td class="tw:pr-4">string | object</td><td>Regras de validação</td></tr>
            <tr class="tw:border-b"><td class="tw:py-2 tw:pr-4 tw:font-mono">as</td><td class="tw:pr-4">string | Component</td><td>Componente a renderizar</td></tr>
            <tr><td class="tw:py-2 tw:pr-4 tw:font-mono">validateOnInput</td><td class="tw:pr-4">boolean</td><td>Valida enquanto digita (padrão: true)</td></tr>
          </tbody>
        </table>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
</script>
